var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import { isEmpty } from '../utils/helpers';
import '../utils/init3rdParties';

class model {

    //region init

    constructor() {}

    static create() {
        return {
            isLoading: false
        };
    }

    //endregion

    //region helper

    static validate(clientModel) {
        throw 'Not implemented method (validate)';
    }

    static isEmpty(model) {
        if (isEmpty(model)) {
            return true;
        }

        const tmp = _extends({}, model);
        delete tmp.isLoading;
        if (isEmpty(tmp)) {
            return true;
        }

        return false;
    }

    //endregion

    //region mapper

    static mapToClient() {
        return {};
    }

    static mapToServer() {
        return {};
    }

    //endregion

    //region action api

    static apiGetBatchData(clientApiMethod, functions, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            functions = functions.filter(function (f) {
                return f && f.apiFunc;
            });
            const promises = functions.map(function (f) {
                return f.apiFunc.bind(_this)(clientApiMethod, f.params, dispatch, failAction);
            });

            Promise.all(promises).then(function (responses) {
                if (!responses) {
                    return;
                }

                functions.forEach(function (f, index) {
                    f.processFunc.bind(_this)(dispatch, f.params, _this, responses[index]);
                });
            }).catch(function (error) {
                functions.map(function (f) {
                    f.errorFunc && f.errorFunc.bind(_this)(dispatch, f.params, _this, error);
                });
                _this.catchRequest(_this, dispatch, failAction)(error);
            });
        })();
    }

    static actionRequestPayload(type, modelClient, model) {
        return {
            type,
            payload: {
                modelClient,
                model
            }
        };
    }

    static actionRequest(type, isLoading, model) {
        return this.actionRequestPayload(type, { isLoading }, model);
    }

    static catchRequest(model, dispatch, failAction) {
        const failCb = failAction ? failAction(dispatch) : error => {
            throw error;
        };

        const failRequestStopWrapperCb = error => {
            dispatch(model.dispatchRequest({ model, isLoading: false }));
            failCb(error);
        };

        return failRequestStopWrapperCb;
    }

    /*
     * params: passed from component for url
     * clientApiMethod: GET, POST, PUT, DELETE
     * modelApiMethod: API method in model (GET, POST, PUT, DELETE)
     * model: one of models in redux-models
     * history: API for history
     * failAction: error handling actions (404, 500, 401, etc ...)
     * */
    static actionApiCall(clientApiMethod, modelApiMethod, model, history, failAction, requestMethodName) {
        return (params = {}) => {
            return dispatch => {

                /* 1 request */
                dispatch(model.dispatchRequest({ model }));
                return modelApiMethod.bind(model)(clientApiMethod, params, dispatch, failAction).then(serverResponse => {
                    /* 2 response*/
                    model.processServerResponse(dispatch, params, model, serverResponse, history, clientApiMethod, requestMethodName);
                })
                /* 3 error */
                .catch(model.catchRequest(model, dispatch, failAction));
            };
        };
    }

    static processServerResponse(dispatch, params, model, serverResponse, history) {
        const modelClient = model.mapToClient(serverResponse);
        dispatch(model.dispatchModel({ modelClient, model }));
    }

    static dispatchRequest(params = {}) {
        const { model } = params;
        return {
            type: model.TYPE_REQUEST,
            payload: params
        };
    }

    static dispatchModel(params = {}) {
        const { model } = params;
        return {
            type: model.TYPE_FROM_SERVER,
            payload: params
        };
    }

    static apiGet() {
        throw 'Not implemented method (apiGet)';
    }

    static apiPost() {
        throw 'Not implemented method (apiPost)';
    }

    //endregion

    //region actions

    static actionClear(model) {
        return dispatch => {
            dispatch(model.dispatchClear({ model }));
        };
    }

    static dispatchClear(params = {}) {
        const { model } = params;
        return {
            type: model.TYPE_CLEAR,
            payload: params
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reducers = {
            [model.TYPE_REQUEST]: model.reduceRequest.bind(model),
            [model.TYPE_FROM_SERVER]: model.reduceGet.bind(model),
            [model.TYPE_CLEAR]: model.reduceClear.bind(model)
        };

        return reducers[type];
    }

    static reduce(state, action, reduceMethod) {
        const { model } = action.payload;
        const stateModel = state[model.MODEL_NAME];
        return _extends({}, state, reduceMethod(stateModel, action, state));
    }

    static reduceRequest(stateModel, action, state) {
        const { model, isLoading } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: isLoading !== false // pass only when false, if did not pass then true
            })
        };
    }

    static reduceGet(stateModel, action, state) {
        const { model, modelClient } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, modelClient, {
                isLoading: false
            })
        };
    }

    static reduceClear(stateModel, action, state) {
        const { model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, model.create())
        };
    }
}

model.MODEL_NAME = '';
model.TYPE_REQUEST = '';
model.TYPE_FROM_SERVER = '';
model.TYPE_CLEAR = '';
export default model;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/base.model.js